import { Minus, Plus } from 'lucide-react';
import { INSTRUMENT_GROUPS } from '@/lib/pitch';

export const InstrumentSelect = ({ value, onChange }) => (
  <label className="flex flex-col gap-2 flex-1 min-w-0">
    <span className="text-[10px] uppercase tracking-[0.3em] text-white/45">Instrument</span>
    <select
      data-testid="tuner-instrument-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="h-12 rounded-xl bg-[#0A0A0A] border border-white/10 px-3 text-sm text-white focus:outline-none focus:border-pink-400 transition-colors"
    >
      {INSTRUMENT_GROUPS.map((g) => (
        <optgroup key={g.key} label={g.label}>
          {g.items.map((i) => (
            <option key={i.id} value={i.id}>{g.perc ? i.name : `${i.name} (${g.key})`}</option>
          ))}
        </optgroup>
      ))}
    </select>
  </label>
);

export const ReferenceControl = ({ value, onChange }) => {
  const set = (v) => onChange(Math.max(430, Math.min(450, v)));
  const btn = 'h-12 w-12 rounded-xl border border-white/10 flex items-center justify-center hover:bg-white/5 active:scale-95 transition-transform';
  return (
    <div className="flex flex-col gap-2">
      <span className="text-[10px] uppercase tracking-[0.3em] text-white/45">Reference A4</span>
      <div className="flex items-center gap-2">
        <button data-testid="tuner-ref-minus" aria-label="A4 -1 Hz" onClick={() => set(value - 1)} className={btn}><Minus className="w-4 h-4" /></button>
        <div data-testid="tuner-ref-value" className="h-12 min-w-[96px] rounded-xl bg-[#0A0A0A] border border-white/10 flex items-center justify-center font-mono text-sm">
          {value} Hz
        </div>
        <button data-testid="tuner-ref-plus" aria-label="A4 +1 Hz" onClick={() => set(value + 1)} className={btn}><Plus className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
